import { render, staticRenderFns } from "./WikiPageSearch.vue?vue&type=template&id=6afa1c46"
import script from "./WikiPageSearch.vue?vue&type=script&lang=ts"
export * from "./WikiPageSearch.vue?vue&type=script&lang=ts"
import style0 from "./WikiPageSearch.vue?vue&type=style&index=0&id=6afa1c46&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports